

import {Component, Input, OnInit, ViewContainerRef} from '@angular/core';
import {ApiAdminImpactService} from "../../../../../services/api/admin/admin-impact-api/admin-impact-api.service";
import {DialogService} from "../../../../../services/dialog-service/dialog.service";
import {AdminImpactComponentDialog} from "./admin-impact-create-edit-dialog/admin-impact-create-edit-dialog.component";
import {ModalConfirmationComponent} from "../../../../../shared/modal-confirmation/modal-confirmation.component";

@Component({
  selector: 'app-admin-impact',
  templateUrl: './admin-impact.html'
})
export class AdminImpactComponent implements OnInit {

  @Input() requestTypeId;

  data;
  isLoading = true;

  constructor(private apiAdminImpactService: ApiAdminImpactService,
              private dialogService: DialogService,
              private viewReference: ViewContainerRef) {  }

  ngOnInit(): void {
    this.getData();
  }

  getData(){
    this.isLoading = true;
    this.apiAdminImpactService.listAll(this.requestTypeId).then(response => {
      this.data = response;
      this.isLoading = false;
    }).catch(error => {
      this.isLoading = false;
      if (error.status === 403) {
        window.location.href = '/';  // Redirect to self-service
      } else {
        console.log('Unhandled error:', error);
      }
    });
  }

  moveUp(id){
    this.apiAdminImpactService.moveUp(this.requestTypeId, id).then(response => {
      this.getData()
    })
  }
  moveDown(id){
    this.apiAdminImpactService.moveDown(this.requestTypeId, id).then(response => {
      this.getData()
    })
  }

  create(){
    // Replace null with Component
    this.dialogService.createDialog(AdminImpactComponentDialog, {id: null, requestTypeId: this.requestTypeId}, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  edit(id){
    // Replace null with Component
    this.dialogService.createDialog(AdminImpactComponentDialog, {id: id, requestTypeId: this.requestTypeId}, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  delete(id){
    this.dialogService.createDialog(ModalConfirmationComponent, 'Are you sure?', this.viewReference)
      .then(confirmed => {
        this.apiAdminImpactService.delete(this.requestTypeId, id).then(response => this.getData())
      }, cancelled => null)
  }



}
